import React from 'react';
import { Form } from 'react-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import { FormGroup, Text, SelectCreatable, Checkbox } from 'components/FormElements/';
import ConfigurationService from 'services/ConfigurationService';
import { toggleLoading, toggleAlertError, updateSettings } from 'stores/actions';
import { greaterOrEqual } from 'constants/InputErrors';

class NetworksEdit extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    ConfigurationService.getConfigurations().then( ( response ) => {
      if( response.data && response.data.data.length ) {
        this.entityId = response.data.data[0].id;
        ConfigurationService.getConfiguration( this.entityId ).then( ( response ) => {
          this.props.toggleLoading( false );

          if( response.data ) {
            response.data.words = _.map( response.data.words, ( word, index ) => {
              return { id: index + 1, word }
            } );

            this.setState( { data: response.data } )
          }
        } )
      }
    } );
  }

  submitForm( data ) {
    const { toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );

    const dataToSend = {
      facebookCharactersLimit: data.facebookCharactersLimit,
      twitterCharactersLimit: data.twitterCharactersLimit,
      emailCharactersLimit: data.emailCharactersLimit,
      smsCharactersLimit: data.smsCharactersLimit,
    };
    ConfigurationService.updateConfiguration( this.entityId, dataToSend ).then( ( response ) => {
      if( response.errors ) return toggleAlertError( response.errors );

      this.props.updateSettings( {
        networkSettings: {
          facebookLimit: data.facebookCharactersLimit ? data.facebookCharactersLimit : -1,
          twitterLimit: data.twitterCharactersLimit ? data.twitterCharactersLimit : -1,
          emailLimit: data.emailCharactersLimit ? data.emailCharactersLimit : -1,
          smsLimit: data.smsCharactersLimit ? data.smsCharactersLimit : -1,
        }
      } );
      toggleAlertError( 'Information updated' );
      toggleLoading( false );
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{<Translate id="edit"/>} {<Translate id="networks"/>}</div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => ( {
              facebookCharactersLimit: greaterOrEqual( values.facebookCharactersLimit, 0 ),
              twitterCharactersLimit: greaterOrEqual( values.twitterCharactersLimit, 0 ),
              emailCharactersLimit: greaterOrEqual( values.emailCharactersLimit, 0 ),
              smsCharactersLimit: greaterOrEqual( values.smsCharactersLimit, 0 ),
            } )}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm} className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="facebookCharactersLimit"/></label>
                  <Text field="facebookCharactersLimit" className="form-control" type="number"/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="twitterCharactersLimit"/></label>
                  <Text field="twitterCharactersLimit" className="form-control" type="number"/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="emailCharactersLimit"/></label>
                  <Text field="emailCharactersLimit" className="form-control" type="number"/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="smsCharactersLimit"/></label>
                  <Text field="smsCharactersLimit" className="form-control" type="number"/>
                </FormGroup>

                <div className="col-md-12 text-right mt-4">
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  updateSettings: ( data ) => {
    dispatch( updateSettings( data ) );
  }
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( NetworksEdit );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/networkLimit/index.js